import { createHostModule } from '@wix/sdk-runtime/host-modules';
export const renderingRuntime = createHostModule({
    env: ({ channel }) => function env(...args) {
        return channel.invoke({
            namespace: 'window',
            method: 'rendering.env',
            args,
        });
    },
});
//# sourceMappingURL=rendering.runtime.js.map